export default "__VITE_ASSET__ZjvIWtHL__"